import { useCallback, useState } from "react";

export const useUserTerms = () => {
  const [isUserTermsChecked, setIsUserTermsChecked] = useState<boolean>(false);

  const handleUserTermsChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setIsUserTermsChecked(event.target.checked);
    },
    [setIsUserTermsChecked]
  );

  return { isUserTermsChecked, handleUserTermsChange };
};
